import { CreditCardReservation } from '@generated-types';

export const kredittbankenReservationsMock1: CreditCardReservation[] = [
    {
        id: '297493148',
        postAmount: -0.1,
        transactionDate: new Date('2025-04-01'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493147',
        postAmount: -0.1,
        transactionDate: new Date('2025-04-01'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493146',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493145',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493144',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493143',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493142',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493141',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493140',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493139',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493138',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493137',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297493136',
        postAmount: -0.01,
        transactionDate: new Date('2025-03-31'),
        description: 'Utbetaling, NOR',
    },
    {
        id: '297408138',
        postAmount: -800.0,
        transactionDate: new Date('2025-02-26'),
        description: 'iZ *Elins Matglede, Trondheim, NOR',
    },
    {
        id: '297408137',
        postAmount: -600.0,
        transactionDate: new Date('2025-02-26'),
        description: 'BILTEMA AVD 288, Trondheim, NOR',
    },
    {
        id: '297408136',
        postAmount: -500.0,
        transactionDate: new Date('2025-02-26'),
        description: 'TUI Norge AS, Trondheim, NOR',
    },
    {
        id: '297408135',
        postAmount: -600.0,
        transactionDate: new Date('2025-02-26'),
        description: 'VINMONOPOLET FINNSNES, Trondheim, NOR',
    },
    {
        id: '297408134',
        postAmount: -200.0,
        transactionDate: new Date('2025-02-26'),
        description: 'DRESSMANN 242, Trondheim, NOR',
    },
    {
        id: '297408133',
        postAmount: -600.0,
        transactionDate: new Date('2025-02-26'),
        description: 'INTERHOME INTERCHALET, Trondheim, NOR',
    },
    {
        id: '297408132',
        postAmount: -600.0,
        transactionDate: new Date('2025-02-26'),
        description: 'NASIR IMAM X-52, Trondheim, NOR',
    },
    {
        id: '297408131',
        postAmount: -400.0,
        transactionDate: new Date('2025-02-26'),
        description: 'VIKEN TAXI AS, Trondheim, NOR',
    },
    {
        id: '297408130',
        postAmount: -700.0,
        transactionDate: new Date('2025-02-26'),
        description: 'INTERHOME INTERCHALET, Trondheim, NOR',
    },
];
